import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

/**
 * Application shell: a fixed left navigation panel and a top bar with the
 * account/notifications actions, wrapping the routed page content. On small
 * screens the sidebar becomes an off-canvas panel toggled from the top bar.
 */
export function AppLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(false);

    const closeSidebar = () => setSidebarOpen(false);
    const toggleSidebar = () => setSidebarOpen((v) => !v);
    const toggleCollapsed = () => setCollapsed((v) => !v);

    return (
        <div className={`app-shell ${collapsed ? 'is-collapsed' : ''}`}>
            <Sidebar open={sidebarOpen} onNavigate={closeSidebar} />

            {sidebarOpen && (
                <button
                    type="button"
                    className="app-sidebar-backdrop"
                    aria-label="Cerrar menú de navegación"
                    onClick={closeSidebar}
                />
            )}

            <div className="app-main">
                <Topbar
                    onToggleSidebar={toggleSidebar}
                    onToggleCollapse={toggleCollapsed}
                    collapsed={collapsed}
                />
                <main className="app-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}

export default AppLayout;
